window.addEventListener('DOMContentLoaded', () => {
    const drlCheckout = document.querySelector('.leenarts-custom-checkout');

    if (drlCheckout === null) {
        return;
    }

    const body = document.querySelector('body');
    const createAccount = document.querySelector('.woocommerce-account-fields input#createaccount');
    const passwordField = document.querySelector('.woocommerce-account-fields input#account_password');
    const setButtons = drlCheckout.querySelectorAll('.drl_checkout_address_choice > a, .pickup-points-error a');

    // Pickup data
    const pickupWrapper = drlCheckout.querySelector('.pickup-points-wrapper');
    const pickupPoints = pickupWrapper.querySelector('.pickup-points');
    const basePoint = pickupWrapper.querySelector('.pickup-points-sample');
    const pickupPointData = pickupWrapper.querySelector('.pickup-point-data input[name="pickup-point-data"]');
    const pickupPointService = pickupWrapper.querySelector('.pickup-point-data input[name="pickup-point-service"]');
    const pickupError = pickupWrapper.querySelector('.pickup-points-error');

    // Delivery time data
    const deliveryWrapper = drlCheckout.querySelector('.delivery-times-wrapper');
    const checkoutForm = drlCheckout.querySelector('form.checkout');
    const shippingFields = drlCheckout.querySelector('.woocommerce-shipping-fields');
    const shippingFieldsHolder = drlCheckout.querySelector('.shipping_address');
    const shippingFieldsCheckbox = drlCheckout.querySelector('#ship-to-different-address-checkbox');
    const showSearchButton = drlCheckout.querySelector('[data-action="show-pickup-search"]');
    const customPickupSearch = drlCheckout.querySelector('.pickup-point-search');

    const postcode = drlCheckout.querySelector('#billing_postcode');
    const number = drlCheckout.querySelector('#billing_housenumber');
    const street = drlCheckout.querySelector('#billing_address_1');
    const city = drlCheckout.querySelector('#billing_city');
    const country = drlCheckout.querySelector('#billing_country');
    global.selectedCountry = getCountryValue(country);

    // Postalcode checker
    const API_AUTH_KEY = 'WQutVDawmOKLouyO';
    let previousPostalCode = '';
    let previousStreet = '';
    let previousHouseNumber = '';

    function getCountryValue(country) {
        let countryValue = country.value;

        if(country.tagName === 'SELECT' ) {
            countryValue = country.options[country.selectedIndex].value;
        }

        return countryValue.toLowerCase();
    }

    function fetchDataIfChanged() {
        let selectedCountry = getCountryValue(country);

        // Only perform zipcode check for Belgium and Netherlands.
        if (selectedCountry !== 'be' && selectedCountry !== 'nl') {
            return;
        }

        const currentPostalCode = postcode.value;
        const currentStreet = street.value;
        const currentHouseNumber = number.value;
        const baseUrl = `https://api.pro6pp.nl/v2/autocomplete/${selectedCountry}?authKey=${API_AUTH_KEY}&postalCode=${currentPostalCode}`;

        let isChanged = currentPostalCode && currentHouseNumber && (currentPostalCode !== previousPostalCode || currentHouseNumber !== previousHouseNumber);
        let url = baseUrl + `&streetNumberAndPremise=${currentHouseNumber}`;
        if (selectedCountry === 'be') {
            isChanged = (currentPostalCode && currentStreet && currentHouseNumber && (currentPostalCode !== previousPostalCode || currentStreet !== previousStreet || currentHouseNumber !== previousHouseNumber));
            url = baseUrl + `&street=${currentStreet}&streetNumber=${currentHouseNumber}`;
        }

        if (!isChanged) {
            return;
        }

        previousPostalCode = currentPostalCode;
        previousHouseNumber = currentHouseNumber;
        previousStreet = currentStreet;

        fetch(url)
            .then((res) => res.json())
            .then((data) => {
                if ('errors' in data) {
                    data.errors.forEach(error => {
                        console.log(error.message);
                    });
                } else {
                    if ('street' in data && selectedCountry === 'nl') {
                        street.value = data.street;
                    }
                    if ('municipality' in data) {
                        city.value = data.municipality;
                    }
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    country.addEventListener('change', fetchDataIfChanged);
    postcode.addEventListener('change', fetchDataIfChanged);
    street.addEventListener('change', fetchDataIfChanged);
    number.addEventListener('change', fetchDataIfChanged);


    // Show delivery times based in selected date.
    $('body').on('change', '.select-date', function() {
        const selected = $(this).find('option:selected').val();
        $(".time").hide();
        $('#' + selected).show();
    });

    // Retrieve on init, fields might be filled already.
    retrieve_pickup_points(postcode, street, number, city, country, pickupWrapper, pickupPoints, pickupError, basePoint);

    if (passwordField !== null && createAccount !== null) {

        // When password is entered, mark create account as checked.
        passwordField.addEventListener('input', (e) => {
            createAccount.checked = e.target.value !== '';
        });
    }

    // Listen to address/pick-up buttons
    setButtons.forEach(elem => {
        elem.addEventListener('click', e => {
            setButtons.forEach(subElem => {
                subElem.dataset.selected = '';
            });

            document.querySelector('[data-action="' + e.currentTarget.dataset.action + '"]').dataset.selected = 'selected';

            if (e.currentTarget.dataset.action === 'set-delivery-home') {
                if (!body.classList.contains('german-site')) {
                    if(deliveryWrapper) {
                        deliveryWrapper.dataset.visible = 'visible';
                    }
                }
                const phoneNumber = document.querySelector('.pickup-points-phone');
                pickupWrapper.dataset.visible = 'false';
                shippingFields.classList.remove('disabled');
                $('input[name=pickup-point]').prop('checked', false);
                $('input[name=pickup-point-data]').val("");
                if(phoneNumber) {
                    phoneNumber.style.display = 'none';
                }
            } else if (e.currentTarget.dataset.action === 'set-delivery-pickup' || e.currentTarget.dataset.action === 'set-delivery-pickup-budbee') {

                if (e.currentTarget.dataset.action == 'set-delivery-pickup-budbee') {
                    const phoneNumber = document.querySelector('.pickup-points-phone');
                    const phoneNumberinput = document.getElementById('billing_phone');

                    if(phoneNumber && phoneNumberinput) {
                        phoneNumber.style.display = 'block';
                        phoneNumberinput.focus();

                        // Validate phone number input
                        phoneNumberinput.addEventListener('blur', () => {
                            validateField(phoneNumberinput);
                        });
                    }


                } else {
                    const phoneNumber = document.querySelector('.pickup-points-phone');
                    if(phoneNumber) {
                        phoneNumber.style.display = 'none';
                    }
                }

                let currentShipper = pickupWrapper.dataset.shipper;
                if( e.currentTarget.dataset.shipper !== currentShipper ) {
                    pickupPointService.value = e.currentTarget.dataset.shipper.toLowerCase();
                    pickupWrapper.dataset.shipper = e.currentTarget.dataset.shipper;
                    retrieve_pickup_points(postcode, street, number, city, country, pickupWrapper, pickupPoints, pickupError, basePoint);
                }
                pickupWrapper.dataset.visible = 'visible';
                if (!body.classList.contains('german-site')) {
                    if(deliveryWrapper) {
                        deliveryWrapper.dataset.visible = 'false';
                    }
                }
                shippingFields.classList.add('disabled');
                shippingFieldsHolder.style.display = 'none';
                shippingFieldsCheckbox.checked = false;
                $('input[name=select_time]').prop('checked', false);
                $('input[name=check_selected_delivery_time]').prop('defaultValue', "");
            }
        });
    });

    // Get pick-up points on change of input
    $('#billing_country').on('change', function(e) {
        drl_update_delivery_data(e, postcode, street, number, country, pickupWrapper, pickupPoints, pickupError, basePoint)
    });

    drlCheckout.addEventListener('change', e => {
        drl_update_delivery_data(e, postcode, street, number, country, pickupWrapper, pickupPoints, pickupError, basePoint)
    });

    // Show/hide pick-up points
    let isVisible = false;

    showSearchButton.addEventListener('click', e => {
        isVisible = !isVisible;
        customPickupSearch.dataset.visible = isVisible ? 'visible' : '';
    });

    function validateField(field) {
		if (!field.checkValidity()) {
			field.reportValidity()
		}
	}

    // Custom Pickup search
    customPickupSearch.addEventListener('change', e => {
        if (e.target.dataset.name === 'number') {
            let customPostcode = customPickupSearch.querySelector('[data-name="postcode"]');
            let customStreet = customPickupSearch.querySelector('[data-name="street"]');
            let customHousenumber = customPickupSearch.querySelector('[data-name="number"]');

            if (customPostcode.value !== '' && customHousenumber.value !== '') {
                retrieve_pickup_points(customPostcode, customStreet, customHousenumber, '', country, pickupWrapper, pickupPoints, pickupError, basePoint);
            }
        }
    });

    // Custom Pickup search button
    customPickupSearch.querySelector('[data-action="search-pickup-points"]').addEventListener('click', e => {
        e.preventDefault();
        let customPostcode = customPickupSearch.querySelector('[data-name="postcode"]');
        let customStreet = customPickupSearch.querySelector('[data-name="street"]');
        let customHousenumber = customPickupSearch.querySelector('[data-name="number"]');

        retrieve_pickup_points(customPostcode, '', customHousenumber, '', country, pickupWrapper, pickupPoints, pickupError, basePoint);
    });

    // When the user changes the pick-up point, change the data.
    checkoutForm.addEventListener('change', e => {
        let selectedPickupPoint = pickupPoints.querySelector('[name=pickup-point]:checked');
        if (selectedPickupPoint !== null) {
            pickupPointData.setAttribute('value', selectedPickupPoint.dataset.data);
        }
    });
});

// GET pickup points
function retrieve_pickup_points(postcode, street, number, city, country, pickupWrapper, pickupPoints, pickupError, basePoint) {
    // Check if all are set.
    if (postcode.value === '' || number.value === '' || city.value === '' || country.value === '') {
        return;
    }

    if( country.value === 'NL' ) {
        retrieve_pickup_points_for_dhl(postcode, street, number, city, country, pickupWrapper, pickupPoints, pickupError, basePoint);
        return;
    }

    let shipper = pickupWrapper.dataset.shipper;

    pickupWrapper.dataset.loading = 'loading';

    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("apikey", "TESTAPIKEY");

    let params = JSON.stringify({
        "carriers": [ shipper ],
        "zipcode": postcode.value,
        "street": street?.value ?? '',
        "houseno": number.value,
        "city": city.value,
        "country": country.value,
        "limit": 6
    });

    let requestOptions = {
        method: 'POST',
        headers: headers,
        body: params,
        redirect: 'follow'
    };

    let url = 'https://customerservice.misi.nl/api/wsParcelShopLocator.dll/getParcelShops';

    fetch(url, requestOptions)
        .then(response => response.text())
        .then(result => {

            result = JSON.parse(result);

            // Clean current results.
            pickupPoints.innerHTML = '';

            let pickup_point_results = result.carriers[0].shops;

            if (pickup_point_results.length > 0) {
                // Hide error
                pickupError.dataset.visible = '';

                pickup_point_results.forEach( pointData => {
                    let htmlPoint = basePoint.cloneNode(true);
                    let pointId = pointData.shopId;

                    htmlPoint.dataset.type = 'pickup-point';
                    htmlPoint.classList.remove('pickup-points-sample');
                    htmlPoint.classList.add('pickup-points__point');

                    let pointDataFormatted = {
                        name: pointData.companyName,
                        carrier: pointData.carrier,
                        address: {
                            street: pointData.street,
                            number: pointData.houseNo,
                            zipCode: pointData.zipcode,
                            city: pointData.city,
                            countryCode: document.getElementById('billing_country').value
                        }
                    }

                    htmlPoint.querySelector('label').setAttribute('for', 'point-' + pointId);
                    htmlPoint.querySelector('input').setAttribute('id', 'point-' + pointId);
                    htmlPoint.querySelector('input').setAttribute('value', pointId);
                    htmlPoint.querySelector('input').dataset.data = JSON.stringify(pointDataFormatted);
                    htmlPoint.querySelector('.data').innerHTML = JSON.stringify(pointDataFormatted);
                    htmlPoint.querySelector('.location').innerHTML = pointData.companyName;
                    htmlPoint.querySelector('.city').innerHTML = pointData.city;
                    htmlPoint.querySelector('.postal_code').innerHTML = pointData.zipcode;
                    htmlPoint.querySelector('.street').innerHTML = pointData.street + ' ' + pointData.houseNo;
                    htmlPoint.querySelector('.start_time').innerHTML = '';
                    pickupPoints.appendChild(htmlPoint);

                });

            } else {
                pickupError.dataset.visible = 'visible';
            }

            pickupWrapper.dataset.loading = '';
        })
        .catch(error => console.log('error', error));
}

function retrieve_pickup_points_for_dhl(postcode, street, number, city, country, pickupWrapper, pickupPoints, pickupError, basePoint) {
    let url = 'https://api-gw.dhlparcel.nl/parcel-shop-locations/' + country.value.toUpperCase() + '?limit=10&postalCode=' + postcode.value + '&serviceType=parcel-last-mile';

    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    let requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
    };

    fetch(url, requestOptions)
        .then(response => response.text())
        .then(result => {
            result = JSON.parse(result);

            // Clean current results.
            pickupPoints.innerHTML = '';

            let pickup_point_results = result;

            if (pickup_point_results.length > 0) {
                // Hide error
                pickupError.dataset.visible = '';

                pickup_point_results.forEach( pointData => {
                    let htmlPoint = basePoint.cloneNode(true);
                    let pointId = pointData.id;

                    htmlPoint.dataset.type = 'pickup-point';
                    htmlPoint.classList.remove('pickup-points-sample');
                    htmlPoint.classList.add('pickup-points__point');

                    let pointDataFormatted = {
                        name: pointData.name,
                        carrier: 'dhl',
                        address: {
                            street: pointData.address.street,
                            number: pointData.address.number,
                            zipCode: pointData.address.postalCode,
                            city: pointData.address.city,
                            countryCode: pointData.address.countryCode
                        }
                    }

                    htmlPoint.querySelector('label').setAttribute('for', 'point-' + pointId);
                    htmlPoint.querySelector('input').setAttribute('id', 'point-' + pointId);
                    htmlPoint.querySelector('input').setAttribute('value', pointId);
                    htmlPoint.querySelector('input').dataset.data = JSON.stringify(pointDataFormatted);
                    htmlPoint.querySelector('.data').innerHTML = JSON.stringify(pointDataFormatted);
                    htmlPoint.querySelector('.location').innerHTML = pointData.name;
                    htmlPoint.querySelector('.city').innerHTML = pointData.address.city;
                    htmlPoint.querySelector('.postal_code').innerHTML = pointData.address.postalCode;
                    htmlPoint.querySelector('.street').innerHTML = pointData.address.street + ' ' + pointData.address.number;
                    htmlPoint.querySelector('.start_time').innerHTML = '';
                    pickupPoints.appendChild(htmlPoint);

                });

            } else {
                pickupError.dataset.visible = 'visible';
            }

            pickupWrapper.dataset.loading = '';
        })
        .catch(error => console.log('error', error));
}

function drl_update_delivery_data(e, postcode, street, number, country, pickupWrapper, pickupPoints, pickupError, basePoint) {
    // Only react when postcode, housenumber or country changes.
    if (e.target.getAttribute('id') === 'billing_postcode' || e.target.getAttribute('id') === 'billing_housenumber' || e.target.getAttribute('id') === 'billing_country') {
        retrieve_pickup_points(postcode, street, number, '', country, pickupWrapper, pickupPoints, pickupError, basePoint);
    }
}

// new selectors
if (document.body.classList.contains('woocommerce-checkout')) {
    // Move login form, into correct div.
    const loginForm = document.querySelector('.woocommerce-new-login-form');
    const loginFormParent = document.getElementById('checkout-loginform');

    if (loginFormParent) {
        loginFormParent.appendChild(loginForm);
        loginForm.removeAttribute('hidden');
    }

    // Show login form
    const alreadyMember = document.getElementById('already-member');
    const createAccountForm = document.getElementById('checkout-create-account');
    const signupCheckbox = document.querySelector('.clubleenarts-signup');

    if(alreadyMember) {
        alreadyMember.addEventListener('click', function(e) {
            e.preventDefault();

            if (createAccountForm.style.display === 'none') {
                createAccountForm.style.display = 'grid';
                loginFormParent.style.display = 'none';
                signupCheckbox.style.display = 'grid';
            } else {
                createAccountForm.style.display = 'none';
                loginFormParent.style.display = 'grid';
                signupCheckbox.style.display = 'none';
            }
        });
    }

    // Guest checkout
    const memberSignup = document.getElementById('member-signup');
    const createAccount = document.getElementById('createaccount');
    const inputNewsletterOptin = document.getElementById('deployteq_newsletter_signup');

    if (memberSignup && createAccount && inputNewsletterOptin) {
        memberSignup.addEventListener('change', (e) => {
            if (e.target.checked) {
                createAccount.checked = true;
                createAccount.value = '1';
                if(!body.classList.contains('da_dk')) {
                    inputNewsletterOptin.checked = true;
                }
            } else {
                createAccount.checked = false;
                createAccount.value = '0';
                if(!body.classList.contains('da_dk')) {
                    inputNewsletterOptin.checked = false;
                }
            }
        });
    }

    // Collapse order review on mobile
    $('#table-toggle').on('click', function(e) {
        e.preventDefault();

        if ($(window).width() < 992) {
            $('.shop_table tbody').toggle();
            $('.table-toggle__price').toggle();
            $('#table-toggle').attr('data-open', $('#table-toggle').attr('data-open') == 'open' ? 'closed' : 'open');
        }
    });

    $(document).on('init_checkout', function(e) {
         $(document).on('click', '#table-toggle', function(e) {
            e.preventDefault();

            if ($(window).width() < 992) {
                $('.shop_table tbody').toggle();
                $('.table-toggle__price').toggle();
                $('#table-toggle').attr('data-open', $('#table-toggle').attr('data-open') == 'open' ? 'closed' : 'open');
            }
        });

        // Check screen width on page load
        if ($(window).width() >= 992) {
            $('.shop_table tbody').show();
        }

        // Show/Close terms modal
        $(document).on('click', '.terms-link', function(e) {
            e.preventDefault();

            let targetClass = $(this).attr('data-target');
            if( typeof targetClass === 'undefined' || targetClass === '' ) {
                targetClass = 'terms';
            }

            targetSelector = '.' + targetClass;

            // Extend jQuery with showModal and closeModal methods
            $.fn.showModal = function() {
                const el = $(this);
                if (el.is('dialog')) {
                    el[0].showModal();
                }
                return el;
            };

            $.fn.closeModal = function() {
                const el = $(this);
                if (el.is('dialog') && el[0].open) {
                    el[0].close();
                    // Remove the click event listener for closing modal when clicking outside
                    $(document).off('click', outsideModalClickHandler);
                }
                return el;
            };

            $(targetSelector).showModal();

            // Close modal when clicked outside
            const outsideModalClickHandler = function(e) {
                const dialog = $(targetSelector)[0]; // Get the first element with target class
                const dialogDimensions = dialog.getBoundingClientRect();
                if (
                    e.clientX < dialogDimensions.left ||
                    e.clientX > dialogDimensions.right ||
                    e.clientY < dialogDimensions.top ||
                    e.clientY > dialogDimensions.bottom
                ) {
                    $(targetSelector).closeModal();
                }
            };

            // Attach click event listener for closing modal when clicking outside
            $(document).on('click', outsideModalClickHandler);

            // Close modal when close button is clicked
            $('.close-dialog').on('click', function() {
                $(targetSelector).closeModal();
            });
        });

    });


    // Initialize flag to track whether resizeAction has been performed
    let resizeAction = false;

    // Check for resize event
    $(window).on('resize', function() {
        let tableToggle = $('#table-toggle');
        let tableBody = $('.shop_table tbody');

        if (!resizeAction && $(window).width() > 992) {
            // Show table body and update data-open attribute
            tableBody.show();
            tableToggle.attr('data-open', 'open');

            resizeAction = true;
        } else if (resizeAction && $(window).width() <= 992) {
            // Hide table body and update data-open attribute
            tableBody.hide();
            $('.table-toggle__price').show();
            tableToggle.attr('data-open', 'closed');

            resizeAction = false;
        }
    });

    // Custom handling of coupon submit (copied from checkout.js of woocommerce, because in our checkout the coupon form is inside the checkout form)
    $('button[form="checkout_apply_coupon"]').on('click', function(e) {
        const $wrapper = $('.coupon-input');
        let data = {
            security:		wc_checkout_params.apply_coupon_nonce,
            coupon_code:	$('input[name="coupon_code"]' ).val()
        };

        // $( '.woocommerce-error, .woocommerce-message, .wc-block-components-notice-banner' ).remove();

        $.ajax({
            type:		'POST',
            url:		wc_checkout_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'apply_coupon' ),
            data:		data,
            success:	function( code ) {
                if ( code ) {
                    $wrapper.before( code );
                    //$wrapper.slideUp();

                    $( document.body ).trigger( 'applied_coupon_in_checkout', [ data.coupon_code ] );
                    $( document.body ).trigger( 'update_checkout', { update_shipping_method: false } );
                }
            },
            dataType: 'html'
        });
    });

    // Add spinners to buttons
    $('.coupon-input button.button').click(function(e) {
        e.preventDefault();
        $('.coupon-spinner-loader').css('display', 'block');
    });

    $('.woocommerce-new-login-form__submit').click(function(e) {
        // e.preventDefault();
        $('.login-spinner-loader').css('display', 'block');
    });

    // Custom handling of checkout errors
    $(document).on('checkout_error', function(e) {
        // Please login link
        if ($('.showlogin')) {
            $('.showlogin').click(function(e) {
                e.preventDefault();

                $('#checkout-create-account').css('display', 'none');
                $('#checkout-loginform').css('display', 'grid');
                $('#username').focus();

            });
        }
    });

    // Custom handling of applied coupon
    $(document).on('applied_coupon_in_checkout', function(e) {
        setTimeout(() => {
            const succcesMessage = document.querySelector('.content .is-success')

            $('.coupon-spinner-loader').css('display', 'none');

            const couponCheck = document.querySelector('.coupon-toggle > details');
            if(couponCheck.getAttribute('open') !== null) {
                couponCheck.removeAttribute('open');
            }

            if (succcesMessage) {
                succcesMessage.remove();
            }
        }, 500)
    });

    // Custom handling of coupon form
    $(window).resize(function() {
        clearTimeout(window.resizedFinished);
        window.resizedFinished = setTimeout(function(){
            if ($(window).width() < 922) {
                $('.woocommerce-checkout__right .coupon-toggle').insertAfter( $('.woocommerce-checkout__left .shop_table'));
            } else {
                $('.woocommerce-checkout__left .coupon-toggle').insertAfter( $('.woocommerce-checkout__right .shop_table'));
            }
        }, 250);
    }).resize();
}

jQuery(document).ready(function($) {
    var typingTimer;
    var typingInterval = 500;

    function isValidEmail(email) {
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    }

    function checkEmailExists(email) {
        if (!isValidEmail(email)) {
            return;
        }

        const spinner = $('#checkout-create-account .woocommerce-input-wrapper');
        spinner.addClass('show-spinner');
        const billingMessage = $('#billing-message');
        billingMessage.html('');

        $.ajax({
            url: '/wp-json/custom/v1/check-email',
            type: 'POST',
            dataType: 'json',
            data: {
                email: email
            },
            success: function(response) {
                spinner.removeClass('show-spinner');

                if (response.exists) {
                    billingMessage.html(response.message);

                    // Show login form
                    const billingAlreadyMember = document.querySelector('.already-member');
                    const createAccountForm = document.getElementById('checkout-create-account');
                    const signupCheckbox = document.querySelector('.clubleenarts-signup');
                    const loginFormParent = document.getElementById('checkout-loginform');

                    if (billingAlreadyMember) {
                        billingAlreadyMember.addEventListener('click', function(e) {
                            e.preventDefault();

                            if (createAccountForm.style.display === 'none') {
                                createAccountForm.style.display = 'grid';
                                loginFormParent.style.display = 'none';
                                signupCheckbox.style.display = 'grid';
                            } else {
                                createAccountForm.style.display = 'none';
                                loginFormParent.style.display = 'grid';
                                signupCheckbox.style.display = 'none';
                            }
                        });
                    }
                } else {
                    billingMessage.html(response.message);
                }
            },
            error: function() {
                console.log('Er is iets misgegaan. Probeer het opnieuw.');
                spinner.removeClass('show-spinner');
            }
        });
    }

    $('#billing_email').on('input', function() {
        var email = $(this).val();
        const billingMessage = $('#billing-message');

        billingMessage.html('');

        clearTimeout(typingTimer);

        if (email.trim() !== '') {
            typingTimer = setTimeout(function() {
                checkEmailExists(email);
            }, typingInterval);
        }
    });
});
